__webpack_require__.p = "/cozyinkk/";